export const getLanguageNativeName = (availableLanguages, iso) =>
    availableLanguages.find(languageObject => languageObject.iso.toLowerCase() === iso.toLowerCase()).nativeName
;

export const generateIsosFromNumericValues = (values, numericEnum) => {
    return values.map(value => numericEnum[value]).join(', ');
};